import { Carousel } from "react-responsive-carousel";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import useFetch from "../../../hooks/useFetch";
import LanguageContext from "../../../context/language-context";
import "../../../css/News.css";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { Link } from "react-router-dom";
export default function NewsInner(props) {
  const { slug } = useParams();
  const languageCtx = useContext(LanguageContext);
  const { loading, error, data } = useFetch(
    `https://spagnoladmin.spagnolcompany.it/api/newss?locale=${languageCtx.languageData}&populate[0]=Page_Heading&populate[1]=News_Items&populate[2]=News_Items.Banner_Image&populate[3]=News_Items.Inner_Images`
  );
  if (loading) return <p>Loading...</p>;
  const { data: details, meta } = data;
  const selectedProducts = details[0].attributes.News_Items.find(
    (item) => item.Title === slug
  );
  const content = selectedProducts.Description;
  let productTitle = selectedProducts.Title;

  if (productTitle.includes(`-`)) {
    productTitle = productTitle.split(`-`).join(` `);
  }
  return (
    <section className="news-inner">
      <div
        className="page-heading"
        style={{
          backgroundImage: `url(https://spagnoladmin.spagnolcompany.it${selectedProducts.Banner_Image.data.attributes.url})`,
        }}
      ></div>
      <div className="news-description">
        <h1 className="news-title">{productTitle}</h1>
        <BlocksRenderer
          content={content}
          blocks={{
            paragraph: ({ children }) => (
              <p className="mt-4 text-base lg:text-xl">{children}</p>
            ),
            heading: ({ children, level }) => {
              const Tag = `h${level}`;
              return (
                <Tag className="mt-4 font-bold text-base lg:text-2xl">
                  {children}
                </Tag>
              );
            },
            list: ({ children, format }) =>
              format === "unordered" ? (
                <ul className="list-disc list-inside ml-6 mt-4">{children}</ul>
              ) : (
                <ol className="list-decimal list-inside ml-6 mt-4">
                  {children}
                </ol>
              ),
            quote: ({ children }) => (
              <blockquote className="border-l-4 border-gray-300 pl-4 font-extrabold text-2xl text-black mt-4 w-[80%]">
                {children}
              </blockquote>
            ),
            link: ({ children, url }) => (
              <Link to={url} className="text-footer underline">
                {children}
              </Link>
            ),
          }}
        />
      </div>
      <Carousel autoPlay={true} infiniteLoop={true} className="carousel-50">
        {selectedProducts.Inner_Images.data.map((item, index) => (
          <img
            key={index}
            src={`https://spagnoladmin.spagnolcompany.it${item.attributes.url}`}
            alt="Bed"
          />
        ))}
      </Carousel>
    </section>
  );
}
